<template>
  <!-- Layout copiado da câmera da Ordem de Carregamento (psecadoranalisefront
       views/camera: Camera.vue, PhotosGallery.vue, Photo.vue). Na lib ela abre como
       diálogo em tela cheia, não como rota, para o formulário continuar montado. -->
  <v-dialog
    :value="value"
    fullscreen
    hide-overlay
    persistent
    no-click-animation
    eager
    transition="dialog-bottom-transition"
    content-class="ol-camera-dialog"
  >
    <div class="ol-cam">
      <div class="ol-cam__appbar primary">
        <button type="button" class="ol-cam__voltar" aria-label="Voltar" :disabled="gravando" @click="$_voltar">
          <v-icon color="white">mdi-arrow-left</v-icon>
        </button>
        <span class="ol-cam__titulo">{{ titulo || 'Capturar Imagem' }}</span>
        <span class="ol-cam__chip">{{ anexados }} {{ anexados === 1 ? 'anexado' : 'anexados' }}</span>
      </div>

      <div class="ol-cam__area">
        <video
          ref="video"
          class="ol-cam__video"
          :class="{ 'ol-cam__video--espelho': facing === 'user', 'ol-cam__video--rec': gravando, 'ol-cam__video--piscando': piscando }"
          playsinline
          muted
          autoplay
        ></video>

        <div v-if="carregando" class="ol-cam__estado">Abrindo câmera…</div>

        <!-- vídeo: relógio vermelho no lugar da chave, como no agrocampo -->
        <div v-if="gravando" class="ol-cam__relogio">
          {{ $$_tempo }} / {{ $$_tempoMax }} · {{ $$_tamanho }}
        </div>
        <div v-else-if="podeVideo" class="ol-cam__modo">
          <button type="button" :aria-pressed="String(modo === 'foto')" @click="$_trocarModo('foto')">FOTO</button>
          <button type="button" :aria-pressed="String(modo === 'video')" @click="$_trocarModo('video')">VÍDEO</button>
        </div>

        <button
          v-if="torchDisponivel"
          type="button"
          class="ol-cam__torch"
          :class="{ 'ol-cam__torch--ativo': torch }"
          aria-label="Lanterna"
          @click="$_lanterna"
        >
          <v-icon :color="torch ? 'black' : 'white'">{{ torch ? 'mdi-flashlight' : 'mdi-flashlight-off' }}</v-icon>
        </button>

        <!-- zoom em barra vertical, só quando o aparelho suporta -->
        <div v-if="zoomCap" class="ol-cam__zoom">
          <span class="ol-cam__zoom-valor">{{ $$_rotuloZoom(zoomAtual) }}</span>
          <input
            class="ol-cam__zoom-barra"
            type="range"
            aria-label="Zoom"
            :min="zoomCap.min"
            :max="zoomCap.max"
            :step="zoomCap.step"
            :value="zoomAtual"
            @input="$_zoom(Number($event.target.value))"
          >
        </div>

        <div v-if="aviso" class="ol-cam__aviso">{{ aviso }}</div>

        <button
          v-if="qtdCameras !== 1"
          type="button"
          class="ol-cam__redondo ol-cam__redondo--esq"
          aria-label="Trocar câmera"
          :disabled="gravando || carregando"
          @click="$_trocarCamera"
        >
          <v-icon>mdi-camera-flip-outline</v-icon>
        </button>
        <button
          type="button"
          class="ol-cam__disparo"
          :class="{ 'ol-cam__disparo--video': modo === 'video' }"
          :aria-label="modo === 'foto' ? 'Tirar foto' : (gravando ? 'Parar gravação' : 'Gravar vídeo')"
          :disabled="carregando || !stream"
          @click="$_disparar"
        >
          <v-icon v-if="modo === 'foto'" color="black" size="34">mdi-camera</v-icon>
          <v-icon v-else-if="gravando" color="red" size="26">mdi-square</v-icon>
          <v-icon v-else color="red" size="34">mdi-circle</v-icon>
        </button>
        <button
          type="button"
          class="ol-cam__redondo ol-cam__redondo--dir"
          aria-label="Escolher da galeria"
          :disabled="gravando || processando"
          @click="$refs.galeria.click()"
        >
          <v-icon>mdi-image</v-icon>
        </button>

        <div ref="faixa" class="ol-cam__faixa">
          <button
            v-for="c in capturas"
            :key="c.id"
            type="button"
            class="ol-cam__item"
            :class="{ 'ol-cam__item--sel': c.id === selecionado }"
            @click="$_abrirAnexar(c.id)"
          >
            <img v-if="c.tipo === 'imagem'" :src="c.url" alt="">
            <video v-else :src="`${c.url}#t=0.1`" muted playsinline preload="metadata"></video>
            <span v-if="c.tipo === 'video'" class="ol-cam__badge">▶ {{ $$_formatarTempo(c.duracao) }}</span>
          </button>
          <span v-if="!capturas.length" class="ol-cam__vazio">
            {{ processando ? 'Processando…' : 'As fotos aparecem aqui. Toque numa para anexar.' }}
          </span>
        </div>
      </div>

      <!-- Diálogo por foto: o "Transferência" do Photo.vue -->
      <div v-if="dialogo" class="ol-cam__scrim" @click.self="dialogo === 'anexar' && $_fecharDialogo()">
        <v-card v-if="dialogo === 'anexar' && $$_sel" class="ol-cam__dialogo">
          <v-card-title class="headline green white--text ol-cam__dialogo-titulo">
            <span>{{ $$_sel.tipo === 'video' ? 'Anexar vídeo' : 'Transferência' }}</span>
            <v-icon large color="white">mdi-content-save</v-icon>
          </v-card-title>
          <v-card-text class="ol-cam__dialogo-texto">
            Digite um nome e selecione 'Enviar' para anexar à pergunta. Em branco, o nome é gerado automaticamente.
          </v-card-text>
          <div v-if="$$_sel.tipo === 'video'" class="ol-cam__dialogo-player">
            <video :src="$$_sel.url" controls playsinline></video>
          </div>
          <div class="ol-cam__dialogo-campo">
            <v-text-field
              v-model="nomeDigitado"
              label="Nome"
              outlined
              autocomplete="off"
              :placeholder="$$_auto"
              persistent-placeholder
              :maxlength="limiteNome"
              counter
              :error-messages="$$_erroNome ? [$$_erroNome] : []"
              :hint="`Será salvo como ${$$_final}`"
              persistent-hint
              @keydown.enter="$_anexar"
            ></v-text-field>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="ol-cam__dialogo-acoes">
            <v-btn text color="red" @click="$_descartarSelecionado">Descartar</v-btn>
            <span class="ol-cam__espaco"></span>
            <v-btn text class="black--text" @click="$_fecharDialogo">Cancelar</v-btn>
            <v-btn color="blue-grey" class="white--text" @click="$_anexar">Enviar</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else-if="dialogo === 'sucesso'" class="ol-cam__dialogo">
          <v-card-title class="headline green white--text ol-cam__dialogo-titulo">
            <span>Sucesso</span>
            <v-icon large color="white">mdi-checkbox-marked-circle-outline</v-icon>
          </v-card-title>
          <v-card-text class="ol-cam__dialogo-texto">
            {{ ultimoTipo === 'video' ? 'O vídeo foi anexado' : 'A imagem foi anexada' }} à pergunta como <b>{{ ultimoNome }}</b>.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="ol-cam__dialogo-acoes">
            <span class="ol-cam__espaco"></span>
            <v-btn color="blue-grey" class="white--text" @click="$_fecharSucesso">Voltar</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else-if="dialogo === 'sair'" class="ol-cam__dialogo">
          <v-card-title class="headline red white--text ol-cam__dialogo-titulo">
            <span>Sair da câmera</span>
            <v-icon large color="white">mdi-alert-circle</v-icon>
          </v-card-title>
          <v-card-text class="ol-cam__dialogo-texto">
            {{ capturas.length === 1
              ? '1 captura ainda não foi anexada e será descartada.'
              : `${capturas.length} capturas ainda não foram anexadas e serão descartadas.` }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="ol-cam__dialogo-acoes">
            <span class="ol-cam__espaco"></span>
            <v-btn text @click="dialogo = null">Continuar</v-btn>
            <v-btn color="red" class="white--text" @click="$_descartarESair">Descartar</v-btn>
          </v-card-actions>
        </v-card>
      </div>

      <input
        ref="galeria"
        class="ol-cam__input"
        type="file"
        accept="image/*,video/*"
        multiple
        @change="$_galeria"
      >
    </div>
  </v-dialog>
</template>

<script>
import errorHandler from '../../utils/error-handler';
import {
  LIMITE_BYTES, LIMITE_NOME, LIMITE_VIDEO_SEGUNDOS, VIDEO_BITS, AUDIO_BITS,
  desenharJpeg, escolherMimeVideo, extensaoPorMime, mimeBase, nomeAutomatico, podeGravarVideo,
  prepararArquivo, sanitizarNome, temCameraWeb, formatarTamanho, formatarTempo,
} from '../../utils/midia';

// Para a gravação um pouco antes de 10 MB: o último pedaço ainda chega depois do stop().
const MARGEM_BYTES = 0.95;
// Piscada do visor ao tirar a foto (mesmo tempo do Camera.vue do Secador).
const PISCADA_MS = 225;

let sequencia = 0;

function mensagemErroCamera(err) {
  const nome = err && err.name;
  if (nome === 'NotAllowedError' || nome === 'SecurityError') return 'A permissão da câmera foi negada.';
  if (nome === 'NotFoundError' || nome === 'OverconstrainedError') return 'Nenhuma câmera foi encontrada neste aparelho.';
  if (nome === 'NotReadableError') return 'A câmera está sendo usada por outro aplicativo.';
  return 'Não foi possível abrir a câmera.';
}

export default {
  name: 'CameraCaptura',

  props: {
    // aberto/fechado (v-model)
    value: {
      type: Boolean,
      default: false,
    },
    // 'foto' | 'video' — modo em que a câmera abre
    modoInicial: {
      type: String,
      default: 'foto',
    },
    // nome da pergunta, exibido na app bar
    titulo: {
      type: String,
      default: '',
    },
    // quantos arquivos a pergunta já tem (chip da app bar)
    anexados: {
      type: Number,
      default: 0,
    },
    // nomes completos já usados na pergunta: o nome novo não pode repetir
    nomesExistentes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      modo: 'foto',
      facing: 'environment',
      stream: null,
      tentativa: 0,
      carregando: false,
      qtdCameras: null,
      zoomCap: null,
      zoomAtual: null,
      torchDisponivel: false,
      torch: false,
      piscando: false,
      capturas: [],
      processando: false,
      aviso: null,

      // diálogo por captura: 'anexar' | 'sucesso' | 'sair' | null
      dialogo: null,
      selecionado: null,
      nomeDigitado: '',
      abertoEm: new Date(),
      ultimoNome: '',
      ultimoTipo: null,
      limiteNome: LIMITE_NOME,

      gravando: false,
      recorder: null,
      chunks: [],
      bytes: 0,
      segundos: 0,
      inicioGravacao: 0,
      timer: null,
      motivoParada: null,
      descartarGravacao: false,

      podeVideo: podeGravarVideo(),
    };
  },

  computed: {
    $$_tempo() {
      return formatarTempo(this.segundos);
    },
    $$_tempoMax() {
      return formatarTempo(LIMITE_VIDEO_SEGUNDOS);
    },
    $$_tamanho() {
      return formatarTamanho(this.bytes);
    },
    $$_sel() {
      return this.capturas.find((c) => c.id === this.selecionado) || null;
    },
    $$_ext() {
      return this.$$_sel ? (extensaoPorMime(this.$$_sel.file.type, this.$$_sel.file.name) || 'bin') : '';
    },
    $$_usados() {
      return new Set(this.nomesExistentes.map((n) => String(n).toLowerCase()));
    },
    $$_digitado() {
      const base = sanitizarNome(this.nomeDigitado);
      return base ? `${base}.${this.$$_ext}` : '';
    },
    $$_auto() {
      if (!this.$$_sel) return '';
      return nomeAutomatico(this.$$_sel.tipo, this.$$_ext, this.$$_usados, this.abertoEm);
    },
    $$_final() {
      return this.$$_digitado || `${this.$$_auto}.${this.$$_ext}`;
    },
    // A API grava em <form>/<questão>/<nome>: nome repetido sobrescreve o outro arquivo.
    $$_erroNome() {
      if (this.$$_digitado && this.$$_usados.has(this.$$_digitado.toLowerCase())) {
        return 'Já existe um arquivo com esse nome nesta pergunta';
      }
      return '';
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(aberto) {
        if (aberto) {
          this.modo = this.modoInicial === 'video' && this.podeVideo ? 'video' : 'foto';
          this.aviso = null;
          this.dialogo = null;
          this.selecionado = null;
          this.$_iniciar();
        } else {
          this.$_encerrar();
        }
      },
    },
  },

  methods: {
    $$_formatarTempo: formatarTempo,
    $$_rotuloZoom(z) {
      return `${(Math.round((z || 1) * 10) / 10).toFixed(1)}x`;
    },

    async $_iniciar() {
      if (!temCameraWeb()) {
        this.$emit('indisponivel', { modo: this.modo, mensagem: 'Este navegador não dá acesso à câmera (a página precisa estar em HTTPS).' });
        return;
      }
      this.carregando = true;
      this.$_pararStream();
      // Troca rápida de modo/câmera dispara vários pedidos; só o último fica com o stream.
      this.tentativa += 1;
      const { tentativa } = this;

      const comAudio = this.modo === 'video';
      const video = { facingMode: { ideal: this.facing } };
      if (comAudio) {
        // Resolução baixa no vídeo: é o que deixa 5 minutos caberem em 10 MB.
        video.width = { ideal: 640 };
        video.height = { ideal: 480 };
        video.frameRate = { ideal: 24, max: 30 };
      } else {
        video.width = { ideal: 1920 };
        video.height = { ideal: 1080 };
      }

      let stream = null;
      let erro = null;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video, audio: comAudio });
      } catch (err) {
        erro = err;
        // Microfone negado não deve impedir o vídeo: grava sem som.
        if (comAudio) {
          try {
            stream = await navigator.mediaDevices.getUserMedia({ video, audio: false });
            this.aviso = 'Gravando sem som: o microfone não foi liberado.';
          } catch (err2) {
            erro = err2;
          }
        }
      }

      // Fechou enquanto pedia permissão, ou outro pedido mais novo já assumiu.
      if (!this.value || tentativa !== this.tentativa) {
        if (stream) stream.getTracks().forEach((t) => t.stop());
        if (!this.value) this.carregando = false;
        return;
      }

      if (!stream) {
        this.carregando = false;
        this.$emit('indisponivel', { modo: this.modo, mensagem: mensagemErroCamera(erro) });
        return;
      }

      this.stream = stream;
      const el = this.$refs.video;
      if (el) {
        el.muted = true;
        el.srcObject = stream;
        try { await el.play(); } catch (e) { /* autoplay já cobre */ }
      }
      this.$_lerCapacidades();
      this.$_contarCameras();
      this.carregando = false;
    },

    // Zoom e lanterna só quando o aparelho informa que tem. No Secador o zoom era
    // lido sem checar e dava "Erro ao ativar a ferramenta de zoom" em vários aparelhos.
    $_lerCapacidades() {
      this.zoomCap = null;
      this.zoomAtual = null;
      this.torchDisponivel = false;
      this.torch = false;
      const [track] = this.stream ? this.stream.getVideoTracks() : [];
      if (!track || !track.getCapabilities) return;
      let caps = {};
      try { caps = track.getCapabilities() || {}; } catch (e) { caps = {}; }
      if (caps.zoom && caps.zoom.max > caps.zoom.min) {
        this.zoomCap = { min: caps.zoom.min, max: caps.zoom.max, step: caps.zoom.step || 0.1 };
        // Sempre abre sem zoom, como o resetSlider() do Secador.
        this.$_zoom(caps.zoom.min);
      }
      this.torchDisponivel = !!caps.torch;
    },

    async $_contarCameras() {
      if (this.qtdCameras != null || !navigator.mediaDevices.enumerateDevices) return;
      try {
        const dispositivos = await navigator.mediaDevices.enumerateDevices();
        this.qtdCameras = dispositivos.filter((d) => d.kind === 'videoinput').length || null;
      } catch (e) {
        this.qtdCameras = null;
      }
    },

    $_zoom(z) {
      const [track] = this.stream ? this.stream.getVideoTracks() : [];
      if (!track) return;
      this.zoomAtual = z;
      track.applyConstraints({ advanced: [{ zoom: z }] }).catch(() => {});
    },

    $_lanterna() {
      const [track] = this.stream ? this.stream.getVideoTracks() : [];
      if (!track) return;
      const ligar = !this.torch;
      track.applyConstraints({ advanced: [{ torch: ligar }] })
        .then(() => { this.torch = ligar; })
        .catch(() => { this.torchDisponivel = false; });
    },

    $_trocarModo(modo) {
      if (this.modo === modo || this.gravando) return;
      this.modo = modo;
      this.aviso = null;
      // Vídeo pede microfone e outra resolução: precisa reabrir o stream.
      this.$_iniciar();
    },

    $_trocarCamera() {
      this.facing = this.facing === 'environment' ? 'user' : 'environment';
      this.$_iniciar();
    },

    $_disparar() {
      if (this.modo === 'foto') this.$_foto();
      else if (this.gravando) this.$_pararGravacao();
      else this.$_iniciarGravacao();
    },

    async $_foto() {
      const el = this.$refs.video;
      if (!el || !el.videoWidth) return;
      this.piscando = true;
      setTimeout(() => { this.piscando = false; }, PISCADA_MS);
      const blob = await desenharJpeg(el, el.videoWidth, el.videoHeight, { espelhar: this.facing === 'user' });
      if (!blob) {
        errorHandler('Não foi possível capturar a foto.');
        return;
      }
      this.$_adicionarCaptura(new File([blob], 'foto.jpg', { type: 'image/jpeg' }), 'imagem', null, 'camera');
    },

    $_iniciarGravacao() {
      if (!this.stream) return;
      const mime = escolherMimeVideo();
      const opcoes = { videoBitsPerSecond: VIDEO_BITS, audioBitsPerSecond: AUDIO_BITS };
      if (mime) opcoes.mimeType = mime;

      let rec;
      try {
        rec = new MediaRecorder(this.stream, opcoes);
      } catch (e) {
        try {
          rec = new MediaRecorder(this.stream);
        } catch (e2) {
          errorHandler('Este aparelho não consegue gravar vídeo pelo navegador.');
          return;
        }
      }

      this.chunks = [];
      this.bytes = 0;
      this.segundos = 0;
      this.motivoParada = null;
      this.descartarGravacao = false;
      this.aviso = null;

      rec.ondataavailable = (ev) => {
        if (!ev.data || !ev.data.size) return;
        this.chunks.push(ev.data);
        this.bytes += ev.data.size;
        if (this.bytes >= LIMITE_BYTES * MARGEM_BYTES && rec.state === 'recording') {
          this.motivoParada = 'tamanho';
          this.$_pararGravacao();
        }
      };
      rec.onstop = () => this.$_finalizarGravacao(rec);

      // Pedaços de 1 s para medir o tamanho enquanto grava.
      rec.start(1000);
      this.recorder = rec;
      this.gravando = true;
      this.inicioGravacao = Date.now();
      this.timer = setInterval(() => {
        this.segundos = Math.floor((Date.now() - this.inicioGravacao) / 1000);
        if (this.segundos >= LIMITE_VIDEO_SEGUNDOS) {
          this.motivoParada = 'tempo';
          this.$_pararGravacao();
        }
      }, 250);
    },

    $_pararGravacao() {
      clearInterval(this.timer);
      this.timer = null;
      if (this.recorder && this.recorder.state !== 'inactive') this.recorder.stop();
    },

    $_finalizarGravacao(rec) {
      clearInterval(this.timer);
      this.timer = null;
      this.gravando = false;
      this.recorder = null;
      const { chunks } = this;
      this.chunks = [];
      if (this.descartarGravacao) {
        this.descartarGravacao = false;
        return;
      }

      const tipo = mimeBase(rec.mimeType || (chunks[0] && chunks[0].type) || 'video/webm');
      const blob = new Blob(chunks, { type: tipo });
      if (!blob.size) return;
      if (blob.size > LIMITE_BYTES) {
        errorHandler('O vídeo passou de 10 MB e foi descartado. Grave um vídeo mais curto.');
        return;
      }
      const duracao = Math.min(
        Math.round((Date.now() - this.inicioGravacao) / 1000),
        LIMITE_VIDEO_SEGUNDOS,
      );
      const file = new File([blob], `video.${extensaoPorMime(tipo) || 'webm'}`, { type: tipo });
      this.$_adicionarCaptura(file, 'video', duracao, 'camera');

      if (this.motivoParada === 'tempo') this.aviso = 'Gravação encerrada: limite de 5 minutos.';
      else if (this.motivoParada === 'tamanho') this.aviso = 'Gravação encerrada: limite de 10 MB.';
      this.motivoParada = null;
    },

    async $_galeria(ev) {
      const files = Array.from(ev.target.files || []);
      // eslint-disable-next-line no-param-reassign
      ev.target.value = '';
      if (!files.length) return;
      this.processando = true;
      const recusados = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const f of files) {
        // eslint-disable-next-line no-await-in-loop
        const r = await prepararArquivo(f);
        if (r.ok) this.$_adicionarCaptura(r.file, r.tipo, r.duracao, 'galeria');
        else recusados.push(r.motivo);
      }
      this.processando = false;
      if (recusados.length) errorHandler(recusados.join(' · '));
    },

    $_adicionarCaptura(file, tipo, duracao, origem) {
      sequencia += 1;
      this.capturas.push({
        id: sequencia,
        file,
        tipo,
        duracao,
        origem,
        url: URL.createObjectURL(file),
      });
      this.$nextTick(() => {
        if (this.$refs.faixa) this.$refs.faixa.scrollLeft = this.$refs.faixa.scrollWidth;
      });
    },

    $_removerCaptura(id) {
      const i = this.capturas.findIndex((c) => c.id === id);
      if (i === -1) return;
      const [c] = this.capturas.splice(i, 1);
      URL.revokeObjectURL(c.url);
    },

    // Toque numa captura da faixa: borda azul + diálogo de nome (Photo.vue).
    $_abrirAnexar(id) {
      if (this.gravando) return;
      this.selecionado = id;
      this.nomeDigitado = '';
      this.abertoEm = new Date();
      this.dialogo = 'anexar';
    },

    $_fecharDialogo() {
      this.dialogo = null;
      this.selecionado = null;
    },

    // "Enviar" do Secador: aqui anexa à pergunta; o upload acontece ao salvar o checklist.
    $_anexar() {
      const c = this.$$_sel;
      if (!c || this.$$_erroNome) return;
      this.ultimoNome = this.$$_final;
      this.ultimoTipo = c.tipo;
      this.$emit('anexar', {
        file: c.file, tipo: c.tipo, duracao: c.duracao, origem: c.origem, nome: this.$$_final,
      });
      this.dialogo = 'sucesso';
    },

    // "Voltar" do diálogo de sucesso tira a captura da faixa, como no Secador.
    $_fecharSucesso() {
      this.$_removerCaptura(this.selecionado);
      this.$_fecharDialogo();
    },

    $_descartarSelecionado() {
      this.$_removerCaptura(this.selecionado);
      this.$_fecharDialogo();
    },

    $_voltar() {
      if (this.capturas.length) {
        this.dialogo = 'sair';
        return;
      }
      this.$emit('input', false);
    },

    $_descartarESair() {
      this.dialogo = null;
      this.$emit('input', false);
    },

    $_pararStream() {
      if (this.stream) this.stream.getTracks().forEach((t) => t.stop());
      this.stream = null;
      const el = this.$refs.video;
      if (el) el.srcObject = null;
    },

    // Desliga tudo. A câmera do Secador nunca parava as tracks e a luz da câmera
    // ficava acesa depois de sair da tela.
    $_encerrar() {
      if (this.gravando) {
        this.descartarGravacao = true;
        this.$_pararGravacao();
      }
      this.$_pararStream();
      this.carregando = false;
      this.dialogo = null;
      this.selecionado = null;
      this.capturas.forEach((c) => URL.revokeObjectURL(c.url));
      this.capturas = [];
    },

    // App em segundo plano: salva o que estava gravando e solta a câmera;
    // ao voltar, reabre.
    $_visibilidade() {
      if (!this.value) return;
      if (document.hidden) {
        if (this.gravando) this.$_pararGravacao();
        this.$_pararStream();
      } else if (!this.stream) {
        this.$_iniciar();
      }
    },
  },

  mounted() {
    document.addEventListener('visibilitychange', this.$_visibilidade);
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.$_visibilidade);
    this.$_encerrar();
  },
};
</script>

<style scoped>
.ol-cam {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #000;
  user-select: none;
}

/* app bar igual à do layout default dos apps (v-app-bar color="primary" dark) */
.ol-cam__appbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 56px;
  padding: 0 12px 0 4px;
  padding-top: env(safe-area-inset-top, 0px);
  box-sizing: content-box;
  color: #fff;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  z-index: 3;
}

.ol-cam__voltar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ol-cam__voltar:disabled {
  opacity: 0.4;
}

.ol-cam__titulo {
  flex: 1;
  min-width: 0;
  font-size: 1.25rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ol-cam__chip {
  flex-shrink: 0;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.22);
}

.ol-cam__area {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: #000;
}

/* Proporções do Camera.vue: vídeo até 76% da altura, botões a 16% do rodapé,
   faixa de fotos com 15%. */
.ol-cam__video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 76%;
  object-fit: contain;
  transition: opacity 0.1s;
}

.ol-cam__video--espelho {
  transform: scaleX(-1);
}

.ol-cam__video--rec {
  box-shadow: inset 0 0 0 3px #f00;
}

.ol-cam__video--piscando {
  opacity: 0;
}

.ol-cam__estado {
  position: absolute;
  top: 38%;
  left: 0;
  right: 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
}

.ol-cam__modo {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  padding: 2px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2;
}

.ol-cam__modo button {
  padding: 5px 12px;
  border-radius: 14px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.08em;
}

.ol-cam__modo button[aria-pressed="true"] {
  background: #fff;
  color: #000;
}

.ol-cam__relogio {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 12px;
  border-radius: 5px;
  background: red;
  color: #fff;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  z-index: 2;
}

.ol-cam__torch {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2;
}

.ol-cam__torch--ativo {
  background: rgba(255, 255, 255, 0.9);
}

/* barra vertical do zoom (input range girado: funciona em navegador antigo também) */
.ol-cam__zoom {
  position: absolute;
  right: 0;
  top: 20%;
  width: 44px;
  height: 36%;
  z-index: 2;
}

.ol-cam__zoom-valor {
  position: absolute;
  top: -22px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 12px;
  color: #fff;
  text-shadow: 0 1px 2px #000;
}

.ol-cam__zoom-barra {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 180px;
  margin: 0;
  transform: translate(-50%, -50%) rotate(-90deg);
  accent-color: #fff;
}

.ol-cam__aviso {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: calc(16% + 84px);
  text-align: center;
  font-size: 13px;
  color: #ffd54f;
  text-shadow: 0 1px 2px #000;
}

.ol-cam__disparo {
  position: absolute;
  left: 50%;
  bottom: 16%;
  transform: translateX(-50%);
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.ol-cam__disparo--video {
  background: #fff;
}

.ol-cam__disparo:disabled {
  opacity: 0.4;
}

.ol-cam__redondo {
  position: absolute;
  bottom: calc(16% + 7px);
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.ol-cam__redondo .v-icon {
  color: #000 !important;
}

.ol-cam__redondo--dir {
  right: 4%;
}

.ol-cam__redondo--esq {
  left: 4%;
}

.ol-cam__redondo:disabled {
  opacity: 0.35;
}

.ol-cam__faixa {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 15%;
  min-height: 72px;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: rgb(20, 20, 20);
  padding-bottom: env(safe-area-inset-bottom, 0px);
  z-index: 2;
}

.ol-cam__item {
  position: relative;
  flex: none;
  height: 100%;
  padding: 0;
  animation: ol-cam-entra 0.5s;
}

.ol-cam__item img,
.ol-cam__item video {
  height: 100%;
  width: auto;
  display: block;
  pointer-events: none;
}

/* seleção do Photo.vue: borda de 6px azul */
.ol-cam__item--sel::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 6px solid hsl(210, 70%, 50%);
}

.ol-cam__badge {
  position: absolute;
  left: 4px;
  bottom: 4px;
  font-size: 10px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  padding: 0 4px;
  border-radius: 3px;
}

.ol-cam__vazio {
  align-self: center;
  padding: 0 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
}

@keyframes ol-cam-entra {
  from { opacity: 0; }
}

.ol-cam__scrim {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(33, 33, 33, 0.46);
}

.ol-cam__dialogo {
  width: 100%;
  max-width: 500px;
  max-height: 100%;
  overflow-y: auto;
}

.ol-cam__dialogo-titulo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
  word-break: normal;
}

.ol-cam__dialogo-texto {
  padding-top: 16px !important;
  font-size: 15px;
}

.ol-cam__dialogo-player {
  padding: 0 24px 12px;
}

.ol-cam__dialogo-player video {
  width: 100%;
  max-height: 32vh;
  background: #000;
  border-radius: 4px;
}

.ol-cam__dialogo-campo {
  padding: 4px 24px 4px;
}

.ol-cam__dialogo-campo >>> input {
  font-size: 1.4em;
}

.ol-cam__dialogo-acoes {
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px 12px;
}

.ol-cam__espaco {
  flex: 1;
}

.ol-cam__input {
  display: none;
}
</style>

<style>
/* content-class do v-dialog fica fora do escopo do componente */
.ol-camera-dialog {
  background: #000;
  overflow: hidden;
}
</style>
